import getAngularService from './get_angular_service';

const notification = {
  success: (message) => {
    const flash = getAngularService('flash');
    const timeout = getAngularService('$timeout');

    timeout(() => {
      flash.success = null;
    }, 50);

    timeout(() => {
      flash.success = message;
    }, 100);
  },

  error: (message) => {
    const flash = getAngularService('flash');
    const timeout = getAngularService('$timeout');

    timeout(() => {
      flash.error = null;
    }, 50);

    timeout(() => {
      flash.error = message;
    }, 100);
  },
};

export default notification;
